import { render, staticRenderFns } from "./CardGauge.vue?vue&type=template&id=7fd12a12&scoped=true"
import script from "./CardGauge.vue?vue&type=script&lang=ts"
export * from "./CardGauge.vue?vue&type=script&lang=ts"
import style0 from "./CardGauge.vue?vue&type=style&index=0&id=7fd12a12&prod&lang=css"
import style1 from "./CardGauge.vue?vue&type=style&index=1&id=7fd12a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd12a12",
  null
  
)

export default component.exports